import { Alert, Link, Typography } from "@mui/material";

import { AlertTitle } from "@mui/lab";
import { useLocales } from "../../../../../locales";
import { Trans } from "react-i18next";

const BreachAlertTips = ({ breaches }) => {
  const breachesCount = breaches.length;
  const { translate } = useLocales();
  const breachWord =
    breachesCount === 1
      ? translate("monitoringPage.breach_one")
      : translate("monitoringPage.breach_other");
  return (
    <Alert
      severity={breachesCount ? "error" : "success"}
      sx={{ mb: 2 }}
      component="span"
    >
      <AlertTitle>
        {translate("monitoringPage.breachesDetectedTitle")}
      </AlertTitle>
      <Typography component="span" variant="inherit">
        <Trans
          i18nKey="monitoringPage.breachesFoundWarning"
          values={{
            number: breachesCount,
            breachWord: breachWord,
          }}
          components={[
            <Typography
              key="0"
              component="span"
              variant="inherit"
              sx={{ fontWeight: 600 }}
            />,

            <Link
              key="1"
              href="https://www.vpnnederland.nl/data-uil/datalek-stappenplan"
              variant="inherit"
              underline="always"
              color="inherit"
            />,
          ]}
        />
      </Typography>
    </Alert>
  );
};

export default BreachAlertTips;
